module.exports = __webpack_public_path__ + "static/media/kpi.cc820b15.svg";